import { apiRoutes } from "../routes/routes";
import api from "../api";
import { FlightSearchParams } from '../types';
import { sellers } from "./agents";


export const search_flights = async (flightParams: FlightSearchParams) => {
    const { data } = await api.get(apiRoutes.search_flights, {params : flightParams});
    return data;
};




export const getImages = async (data: any) => {
    try {
      const response = await api.get(apiRoutes.itinerary_images, {
        params: { destination: data.arrive_city_english ? data.arrive_city_english : data.arrive_city },
      });
      data.images = response.data.images;
    } catch (err) {

    }
  };


export const updateItinerary = async (itinerary_uuid: string, data: any) => {
    try {

      const response = await api.patch(
        apiRoutes.itinerary_detail.replace(':uuid', itinerary_uuid), 
        data
        );

    } catch (err) {

    }
}


export const getAgents = (country_from: string, country_to: string, mode: string = "all") => {
  const agent_ids: number[] = [];

  sellers.forEach(
    (seller) => {
      seller.countries.forEach(
        countries => {
          if(countries.includes(country_from) && countries.includes(country_to) && 
          (mode == "all" || seller.modes.includes(mode))
        ){
            agent_ids.push(seller.id)
            return;
          }
        }
      )
    }
  );

  return agent_ids;
}